import _classCallCheck from "/home/runner/work/my.phone.com/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/my.phone.com/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import { Levels } from "./levels";
/**
 * Logger.
 * @public
 */
export var Logger = /*#__PURE__*/function () {
  function Logger(logger, category, label) {
    _classCallCheck(this, Logger);
    this.logger = logger;
    this.category = category;
    this.label = label;
  }
  _createClass(Logger, [{
    key: "error",
    value: function error(content) {
      this.genericLog(Levels.error, content);
    }
  }, {
    key: "warn",
    value: function warn(content) {
      this.genericLog(Levels.warn, content);
    }
  }, {
    key: "log",
    value: function log(content) {
      this.genericLog(Levels.log, content);
    }
  }, {
    key: "debug",
    value: function debug(content) {
      this.genericLog(Levels.debug, content);
    }
  }, {
    key: "genericLog",
    value: function genericLog(level, content) {
      this.logger.genericLog(level, this.category, this.label, content);
    }
  }, {
    key: "level",
    get: function get() {
      return this.logger.level;
    },
    set: function set(newLevel) {
      this.logger.level = newLevel;
    }
  }]);
  return Logger;
}();